import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceUserGuidesStringsQuickLinks',
})
export class ReplaceUserGuidesStringsQuickLinksPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    value = value.replace('MONTAGEdc', 'MONTAGEdc User Guides');
    value = value.replace('RESEARCHit', 'RESEARCHit User Guides');
    value = value.replace('SHAREit', 'SHAREit User Guides');
    value = value.replace('VERSO', 'VERSO User Guides');
    return value;
  }
}
